import React from 'react';
import { useSelector } from 'react-redux';
import SelectCampaigns from '../../components/SelectCampaigns/SelectCampaigns';
import SelectClient from '../../components/SelectClient/SelectClient';
import SetBudget from '../../components/SetBudget/SetBudget';
import useCreateBudgetFlow from '../../hooks/createBudgets/useCreateBudgetFlow';
import css from './CreateBudget.module.css';
import ConfirmDialog from './components/ConfirmDialog';
import StepGuard from './components/StepGuard';
import StepNav from './components/StepNav';

const CreateBudget = () => {
  const { currentStep, step, isConfirm } = useSelector(s => s.createBudget);
  const { isNewDataSource } = useSelector(s => s.dataSource);
  const {
    handleClosePopup,
    handleConfirm,
    getCampaignsProps,
  } = useCreateBudgetFlow();

  return (
    <div className={css.main}>
      {isConfirm ? (
        <ConfirmDialog onClose={handleClosePopup} onConfirm={handleConfirm} />
      ) : (
        <>
          <StepNav currentStep={currentStep} step={step} />
          {step === 'client' && <SelectClient />}
          {step === 'budget' && (
            <StepGuard allow={currentStep >= 2}>
              <SetBudget />
            </StepGuard>
          )}
          {step === 'campaigns' && (
            <StepGuard allow={currentStep >= 3}>
              <SelectCampaigns
                {...getCampaignsProps()}
                isNewDataSource={isNewDataSource}
              />
            </StepGuard>
          )}
        </>
      )}
    </div>
  );
};

export default CreateBudget;